import { COOKIE, COOKIE_BANNER } from "../types/cookie/constants";

export abstract class CookieBanner {
  static isEnabled(): boolean {
    if (window.o_util && window.o_util.cookie && window.o_util.cookie.get) {
      return window.o_util.cookie.get(COOKIE.CB) == COOKIE_BANNER.ENABLED;
    }
    return false;
  }
}
